var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SimpleSVG,_vm._b({attrs:{"custom-id":_setup.svgId},on:{"load":_setup.onSVGLoaded},nativeOn:{"mouseleave":function($event){return _setup.mouseLeave.apply(null, arguments)},"mouseover":function($event){return _setup.mouseOver.apply(null, arguments)}}},'SimpleSVG',_setup.svgProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }